import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ReportProvider, useReport } from '../../contexts/ReportContext';
import ReportView from './ReportView';
import { CircularProgress, Box } from '@mui/material';

const ReportLoaderContent = () => {
  const { reportId } = useParams();
  const { setReportId, loading } = useReport();

  useEffect(() => {
    if (reportId) {
      setReportId(reportId);
    }
  }, [reportId, setReportId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <ReportView />;
};

const ReportLoader = () => {
  return (
    <ReportProvider>
      <ReportLoaderContent />
    </ReportProvider>
  );
};

export default ReportLoader;